window.abi = require('../../../deployed_abis/mecha.json');
import Web3 from "web3";
import { ethers } from "ethers";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import JSConfetti from 'js-confetti'

window.Web3 = Web3;
window.Web3Modal = Web3Modal;
window.ethers = ethers;
window.confetti = new JSConfetti()


export default (wire) => ({
    networkId: null,
    networkData: null,
    abi: null,
    balance: null,
    totalSupply: null,
    price: null,
    errormessage: '',
    showError: false,
    processing: false,
    mintButtonText: "Loading",
    numberOfNfts: 3,
    buttonDisabled: false,
    wire: wire,

    async init() {
        Alpine.effect(async () => {
            if (_.isEmpty(this.$store.provider.web3) || _.isEmpty(this.$store.provider.walletAddress)) {
                this.mintButtonText = "Connect your wallet using button in header to mint a Kevin";
            } else {
                this.contract = new this.$store.provider.web3.eth.Contract(JSON.parse(JSON.stringify(window.abi)), process.env.MIX_CONTRACT_ADDRESS)
                this.price = await this.contract.methods.mintPrice().call()
                this.totalSupply = await this.contract.methods.totalSupply().call()
                this.balance = await this.contract.methods.balanceOf(this.$store.provider.walletAddress).call()
                this.mintButtonText = "Mint Your Kevin";
            }
        })
    },

    async mintFree() {
        if (_.isEmpty(this.$store.provider.web3) || _.isEmpty(this.$store.provider.walletAddress)) {
            this.errormessage = 'Connect your wallet using button in header to mint a Kevin'
            this.showError = true;
            return;
        }
        console.log(this.balance);
        if (this.balance >= 3) {
            this.errormessage = 'Cannot claim as you already own 3 or more Kevins...'
            this.showError = true;
            return;
        }

        let canClaimNumber = await this.wire.howManyCanIClaim(this.$store.provider.walletAddress);
        console.log(canClaimNumber);
        if (canClaimNumber < 1) {
            this.errormessage = 'You do not hold any collection that is allowed to claim, you must hold a MechaPenguin, SappySeal, or a Vinyl Verse Item';
            this.showError = true;
            return;
        }

        if (this.numberOfNfts > 3) {
            this.errormessage = 'You can only claim 3 free ones.';
            this.showError = true;
            return;
        }

        const networkId = await this.$store.provider.web3.eth.net.getId();
        if (networkId == 1) {
            if (this.contract) {
                const price = Number(this.price * this.numberOfNfts)
                const gasAmount = await this.contract.methods.claimKevins(this.numberOfNfts)
                    .estimateGas({
                        from: this.$store.provider.walletAddress
                    }).catch((error) => {
                        console.log(error)
                        this.errormessage = error.message;
                        this.showError = true;
                    });
                this.$nextTick(() => {
                    this.contract.methods
                        .claimKevins(this.numberOfNfts)
                        .send({
                            from: this.$store.provider.walletAddress,
                            gas: String(gasAmount)
                        })
                        .on('transactionHash', (hash) => {
                            console.log("transactionHash", hash)
                            this.$store.provider.web3.eth.getTransactionReceipt(hash).then((data) => {
                                window.confetti.addConfetti({
                                    emojis: ['💚'],
                                })

                                this.mintButtonText = "Enjoy!";
                                this.buttonDisabled = true;
                                this.showError = true;
                                this.errormessage = 'Welcome to KevinNation!'
                            });
                        })
                })
            } else {
                console.log("Wallet not connected")
            }
        } else {
            window.alert('Connect to the etheruem mainnet to mint');
        }
    },

    async mint() {
        if (_.isEmpty(this.$store.provider.web3) || _.isEmpty(this.$store.provider.walletAddress)) {
            this.errormessage = 'Connect your wallet using button in header to mint a Kevin'
            this.showError = true;
            return;
        }
        console.log(this.balance);
        if (this.balance >= 20) {
            this.errormessage = 'Cannot mint more as you already own 20 or more Kevins...'
            this.showError = true;
            return;
        }
        const networkId = await this.$store.provider.web3.eth.net.getId();
        if (networkId == 1) {
            if (this.contract) {
                const price = Number(this.price * this.numberOfNfts)
                const gasAmount = await this.contract.methods.mint(this.numberOfNfts)
                    .estimateGas({
                        from: this.$store.provider.walletAddress,
                        value: price
                    }).catch((error) => {
                        console.log(error)
                        this.errormessage = error.message;
                        this.showError = true;
                    });
                this.$nextTick(() => {
                    this.contract.methods
                        .mint(this.numberOfNfts)
                        .send({
                            from: this.$store.provider.walletAddress,
                            value: price,
                            gas: String(gasAmount)
                        })
                        .on('transactionHash', (hash) => {
                            console.log("transactionHash", hash)
                            this.$store.provider.web3.eth.getTransactionReceipt(hash).then((data) => {
                                window.confetti.addConfetti({
                                    emojis: ['💚'],
                                })

                                this.mintButtonText = "Thank you!";
                                this.buttonDisabled = true;
                                this.showError = true;
                                this.errormessage = 'Welcome to KevinNation!'
                            });
                        })
                })
            } else {
                console.log("Wallet not connected")
            }
        } else {
            window.alert('Connect to the etheruem mainnet to mint');
        }
    },

})
